import * as React from 'react'
import { observer } from 'mobx-react'
import { CancelUserTransactionViewModel } from '../../CancelUserTransactionViewModel'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
  ModalSheetContentIllustration,
  ModalSheetContentBlock,
} from 'components/ModalSheet'
import Button from 'components/Button'
import ErrorBlock from 'components/ErrorBlock'
import styles from './CancelUserTransactionModal.sass'

interface CancelUserTransactionModalProps {
  vm: CancelUserTransactionViewModel
}

/**
 * The CancelUserTransactionModal
 */
export default observer(function CancelUserTransactionModal({
  vm,
}: CancelUserTransactionModalProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <>
        <ModalSheetHeader withCloseButton />
        <ModalSheetContent>
          <ModalSheetContentIllustration
            src={require('assets/images/img_remove-collaborator.svg')}
          />
          <ModalSheetContentBlock>
            <ModalSheetContentTitle>
              You are about to cancel a transaction
            </ModalSheetContentTitle>
            <ModalSheetContentDescription>
              Are you sure you want to cancel transaction{' '}
              <span className={styles.transactionId}>
                {vm.transaction.shortId}
              </span>
              ? This action cannot be undone.
            </ModalSheetContentDescription>
          </ModalSheetContentBlock>
        </ModalSheetContent>
        {vm.cancelTransaction.error && (
          <ErrorBlock tackOn="bottom" error={vm.cancelTransaction.error} />
        )}
        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button onClick={vm.close} disabled={vm.cancelTransaction.pending}>
              Close
            </Button>
            <Button
              type="danger"
              disabled={vm.cancelTransaction.pending}
              loading={vm.cancelTransaction.pending}
              onClick={vm.cancelTransaction}
            >
              Cancel Transaction
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </>
    </ModalSheet>
  )
})
